import { clsx } from "clsx";
import { DARK_MODE } from "./dark-mode";
import { publicVariables } from "../../theme/theme.css";

type Props = {
  className?: string;
};

export const Lock = ({ className }: Props) => (
  <svg
    className={clsx(className)}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <style>{DARK_MODE}</style>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.99998 0.522587L6.97554 0.522584H6.97546C6.81142 0.52257 6.69763 0.522561 6.59677 0.529171C5.05691 0.630098 3.83033 1.85668 3.7294 3.39654C3.72279 3.49741 3.7228 3.61122 3.72282 3.7753V3.77531L3.72282 3.79974V5.58433C3.59225 5.62566 3.47355 5.67717 3.36237 5.74136C2.99372 5.9542 2.68758 6.26034 2.47474 6.62899C2.14984 7.19173 2.14984 7.94724 2.14984 9.45825C2.14984 10.9693 2.14984 11.7248 2.47474 12.2875C2.68758 12.6562 2.99372 12.9623 3.36237 13.1751C3.92511 13.5 4.68062 13.5 6.19163 13.5H7.80832C9.31933 13.5 10.0748 13.5 10.6376 13.1751C11.0062 12.9623 11.3124 12.6562 11.5252 12.2875C11.8501 11.7248 11.8501 10.9693 11.8501 9.45825C11.8501 7.94724 11.8501 7.19173 11.5252 6.62899C11.3124 6.26034 11.0062 5.9542 10.6376 5.74136C10.5264 5.67717 10.4077 5.62566 10.2771 5.58433V3.79974L10.2771 3.77533V3.77522C10.2771 3.61119 10.2772 3.49739 10.2705 3.39654C10.1696 1.85668 8.94304 0.630098 7.40318 0.529171C7.30232 0.522561 7.18853 0.52257 7.02449 0.522584H7.02441L6.99998 0.522587ZM8.97713 5.42517V3.79974C8.97713 3.6018 8.97678 3.53419 8.97333 3.48156C8.91507 2.59268 8.20703 1.88465 7.31816 1.82639C7.26552 1.82294 7.19792 1.82259 6.99998 1.82259C6.80203 1.82259 6.73443 1.82294 6.68179 1.82639C5.79292 1.88465 5.08488 2.59268 5.02662 3.48156C5.02317 3.53419 5.02282 3.6018 5.02282 3.79974V5.42517C5.3548 5.41646 5.73937 5.41646 6.19163 5.41646H7.80832C8.26058 5.41646 8.64515 5.41646 8.97713 5.42517ZM6.99997 7.7978C7.35896 7.7978 7.64997 8.08882 7.64997 8.4478V10.4687C7.64997 10.8277 7.35896 11.1187 6.99997 11.1187C6.64099 11.1187 6.34997 10.8277 6.34997 10.4687V8.4478C6.34997 8.08882 6.64099 7.7978 6.99997 7.7978Z"
      // HACK: fill color is used as inlined style here to override the color setting from DARK_MODE variable
      style={{ stroke: publicVariables.color.foreground }}
    />
  </svg>
);
